import { render, staticRenderFns } from "./dashboard-repayment-summary.vue?vue&type=template&id=0c72e4fc&scoped=true&"
import script from "./dashboard-repayment-summary.vue?vue&type=script&lang=js&"
export * from "./dashboard-repayment-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c72e4fc",
  null
  
)

export default component.exports